import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { CalculationService, DataService, DateService, HelperService, HTTPService, ValidationService } from 'app/services';
import { config, paymentTypes } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { paymentObject } from 'app/services/sharedInterfaces';

import { environment } from 'environments/environment';

import { orderBy, sum } from 'lodash';
import { Subscription } from 'rxjs';
import { currency } from 'app/constants/currency.constants';
@Component({
  selector: 'app-view-payment',
  templateUrl: './view-payment.component.html',
  styleUrls: ['./view-payment.component.scss'],
  providers: [DialogService],
})
export class ViewPaymentComponent implements OnInit {
  // required input ids
  isArchived: boolean;
  estimateSearchResults: any[] = [];
  customerSearchResults: any[] = [];
  paymentMethods: any[] = [];
  cashPaymentMethods: any[] = [];
  cardPaymentMethods: any[] = [];
  otherPaymentMethods: any[] = [];
  defaultTitle: string = config.defaultTitle;
  noCustomerText: string = config.noCustomerTitle;
  noEmailText: string = config.noEmail;
  usd = currency.USD;
  selectedPaymentMethod: any = {};
  previousCollectedAmount: number = 0;
  validate: any = {};
  remainingBalance: any = 0;
  paymentId: any;
  reviewConfiguration: any;
  isLoadingResults: boolean = true;
  disabled: boolean = false;
  workFlowDisabled: boolean = false;
  isProcessing: boolean = false;
  isNewPayment: boolean = true;
  isOrderEditable: boolean = true;
  isCustomerEditable: boolean = true;
  paymentHistory: any = [];
  focus: any = { collectedAmount: false };
  paymentTypes: any[] = paymentTypes;
  paymentMethodsActive = {
    cheque: true,
    cash: true,
    card: true,
  };
  maxDateRange: any = new Date();
  activePayment: any = this.paymentTypes[0];
  payRixResponse: any = {};
  payment: any = {
    _id: '',
    title: '',
    refundTypeTitle: 'Payment',
    code: '',
    payrixResponse: this.payRixResponse,
    isOnline: false,
    paymentProvider: '',
    paymentType: this.activePayment.value,
    collectedAmount: null,
    isPaidFull: false,
    workFlowPaid: false,
    paid: 0,
    customer: {
      customerId: '',
      fullName: '',
      email: '',
      phone: '',
    },
    vehicle: {
      vehicleId: '',
      name: '',
    },
    estimate: {
      estimateId: '',
      title: '',
      code: '',
      invCode: '',
      estimateBy: '',
      cash: 0,
      cheque: 0,
      card: 0,
      creditPayment: 0,
      thirdParty: 0,
      total: 0,
    },
    method: {
      methodId: '',
      qboId: '',
      name: '',
      type: '',
    },
    cardType: '',
    card4Digits: '',
    cardConfNo: '',
    checkNo: '',
    notes: '',
  };
  isSearching: boolean = false;
  paymentTime: any = '';
  isQboConnected: any = false;
  collectedAmmount: any;
  confirmCardPattern: any = { '0': { pattern: new RegExp('[a-zA-Z0-9]') } };
  isConfigLoading: boolean = false;
  isPaymentLoading: boolean = false;
  isMethodLoading: boolean = false;
  enableMandatoryVin: boolean = false;
  orderVehicle: any = {};
  isPaymentOnline = false;
  showNotes = true;
  dataServiceSubscription: Subscription;
  win: any;
  opening = false;
  featureIsPayRixEnable: boolean;
  isPayrixConnected: Boolean;
  merchantId: string;
  apiKey: string;
  //  to show card drop down, confirmation and last 4 digits
  afterPayrixPayment = false;

  private credentials: paymentObject;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    public validationService: ValidationService,
    public dataService: DataService,
    public dateService: DateService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private calculationService: CalculationService,
    private cdr: ChangeDetectorRef
  ) {
    this.featureIsPayRixEnable = this.dataService.isOnlinePaymentEnable;
    this.isPayrixConnected = this.dataService.isPayrixConnected;
    if (this.featureIsPayRixEnable) {
      this.httpService.getPayrixInfo().then(({ hash }: any) => {
        if (hash !== '') {
          this.credentials = this.helperService.decryptPaymentData(hash);
          setTimeout(() => {
            this.merchantId = this.credentials.merchantId;
            this.apiKey = this.credentials.apiKey;
          });
        }
      });
    }
  }

  ngOnInit() {
    const data = this.dConfig.data;
    this.getReviewConfiguration();
    this.fetchPaymentMethods();
    this.isQboConnected = this.helperService.getCompany().qbo;

    if (data) {
      this.isNewPayment = data.isNewPayment;
      this.isCustomerEditable = data.isNewPayment;
      this.isOrderEditable = data.isNewPayment;
      this.paymentId = data.paymentId ? data.paymentId : '';
      const estimate = data.estimate ? data.estimate : '';

      if (this.paymentId) {
        this.getPaymentDetails();
      }

      if (estimate) {
        this.setEstimateDetails(estimate);
      }
    }

    this.setDataService();
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  setDataService() {
    this.enableMandatoryVin = this.dataService.enableMandatoryVin;
    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.enableMandatoryVin = this.dataService.enableMandatoryVin;
        }

        if (data.key === 'update-order-customer-close' && this.orderVehicle._id) {
          this.isProcessing = true;
          this.httpService
            .getVehicleById(this.orderVehicle._id)
            .then((orderVehicle) => {
              this.orderVehicle = orderVehicle;
            })
            .finally(() => {
              this.isProcessing = false;
            });
        }
      }
    });
  }

  /** Getting review configuration */
  getReviewConfiguration() {
    this.isConfigLoading = true;
    this.httpService.getReviewConfiguration().then(
      (configuration) => {
        this.reviewConfiguration = configuration;
        this.paymentTime = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        const maxDateRange = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        this.maxDateRange = new Date(maxDateRange);
        this.isConfigLoading = false;
      },
      (err) => {
        this.isConfigLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  /** Getting payment details */
  getPaymentDetails() {
    this.isPaymentLoading = true;
    this.httpService.getPaymentById(this.paymentId).then(
      (payment: any) => {
        if (payment) {
          this.isArchived = payment.estimate.estimateId.isArchived;
          this.setPaymentDetails(payment);
        }

        this.isPaymentLoading = false;
      },
      (err) => {
        this.isPaymentLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  clearSearchResult(type: string) {
    this.isSearching = false;
    if (type === 'order') {
      this.estimateSearchResults = [];
    } else {
      this.customerSearchResults = [];
    }
  }

  toggleEditMode(type: string) {
    if (this.isNewPayment) {
      if (type === 'order') {
        this.isOrderEditable = !this.isOrderEditable;
      } else {
        this.isCustomerEditable = !this.isCustomerEditable;
      }
    }
  }

  /** Getting amount from the input box and calculating the remaining balance */
  handleChange(value: any, field: string) {
    if (field === 'collectedAmount') {
      this.payment[field] = Number(value.replace(',', ''));
    } else if (field !== 'card4Digits' && field !== 'cardConfNo' && field !== 'checkNo') {
      this.payment[field] = Number(value);
    } else {
      this.payment[field] = value;
    }

    this.calculateRemainingBalance();
  }

  /** Calculate remaining amount */
  calculateRemainingAmount() {
    const { total, cash, card, cheque, creditPayment, thirdParty } = this.payment.estimate;
    let remaining = 0;
    if (this.paymentId) {
      if (this.payment.refundTypeTitle === 'Void') {
        remaining = total - (cash + card + cheque + creditPayment + thirdParty);
      } else {
        remaining = total + this.previousCollectedAmount - (cash + card + cheque + creditPayment + thirdParty);
      }
    } else {
      remaining = total - (cash + card + cheque + creditPayment + thirdParty);
    }

    return this.calculationService.roundOff(remaining);
  }

  /** Calculate and set remaining amount */
  calculateRemainingBalance() {
    this.collectedAmmount = -1;
    const { total = 0, cash = 0, card = 0, cheque = 0, creditPayment = 0, thirdParty = 0, unpaid = 0 } = this.payment.estimate;
    const amount = this.payment.collectedAmount;
    const remainingAmount = this.calculateRemainingAmount();

    if (amount && amount <= remainingAmount) {
      if (this.paymentId) {
        this.remainingBalance = total + this.previousCollectedAmount - (amount + cash + card + cheque + creditPayment + thirdParty);
      } else {
        this.remainingBalance = total - (amount + cash + card + cheque + creditPayment + thirdParty);
      }

      this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      this.validate.amount = '';
    } else if (!amount) {
      if (this.paymentId) {
        this.remainingBalance = total + this.previousCollectedAmount - ((amount || 0) + cash + card + cheque + creditPayment + thirdParty);
        this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      } else {
        this.remainingBalance = total - ((amount || 0) + cash + card + cheque + creditPayment + thirdParty);
        this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);
      }
    } else {
      this.collectedAmmount = 0;
      this.remainingBalance = this.calculateRemainingAmount();
    }

    if (this.remainingBalance < 0.45) {
      this.payment.isPaidFull = true;
      this.payment.workFlowPaid = true;
    } else {
      if (!this.disabled) {
        this.payment.isPaidFull = false;
      }

      if (!this.workFlowDisabled) {
        this.payment.workFlowPaid = false;
      }
    }
  }

  onEstimateSearch(value: string) {
    let query = '';
    query = `search=${value}&sort=createdAt&order=-1&activeOnly=false&limit=20&skip=0`;

    this.isSearching = true;
    this.httpService.estimateSearch(query).then(
      (estimates) => {
        if (estimates.records && estimates.records.length) {
          this.estimateSearchResults = estimates.records.map((estimate: any) => ({
            ...estimate,
            isArchived: !estimate.isArchived,
          }));
        }
        this.isSearching = false;
      },
      (err) => {
        this.isSearching = false;
        this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
      }
    );
  }

  onCustomerSearch(event: string) {
    if (event) {
      this.httpService.searchCustomer(event.trim(), { limit: 50 }).then(
        (customer: any[]) => {
          const filter = customer;
          this.customerSearchResults = filter;
        },
        (err) => {
          this.helperService.showToaster('error', this.helperService.getErrorMsg(err));
        }
      );
    } else {
      this.customerSearchResults = [];
    }
  }

  onEstimateSearchSelect(estimate) {
    this.isCustomerEditable = false;
    this.isOrderEditable = false;
    this.setEstimateDetails(estimate);
  }

  onCardTypeSelect(card: any) {
    this.payment.cardType = card.name;
    this.selectedPaymentMethod = card;
  }

  onCustomerSearchSelect(customer) {
    this.payment.customer = {
      customerId: customer._id,
      fullName: customer.fullName,
      phone: customer.phone,
      phone2: customer.phone2,
      displayName: customer.fullNameQBO,
      notes: customer.notes,
      companyName: customer.companyName,
      isFleetCustomer: customer.isFleetCustomer,
      email: customer.email,
    };
    this.isCustomerEditable = false;
    this.isOrderEditable = true;
    this.payment = {
      ...this.payment,
      isPaidFull: false,
      workFlowPaid: false,
      estimate: {
        estimateId: '',
        title: '',
        code: '',
        invCode: '',
        estimateBy: '',
        cash: 0,
        cheque: 0,
        card: 0,
        total: 0,
      },
    };
    this.estimateSearchResults = [];
    this.remainingBalance = 0;

    const query = `customerId=${customer._id}`;
    this.httpService.estimateSearch(query).then(
      (estimates) => {
        if (estimates.records && estimates.records.length) {
          this.estimateSearchResults = estimates.records;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onDateTimeChange(date: any) {
    this.payment.paymentDate = date;
  }

  closePaymentModal(data: any) {
    this.ref.close(data);
  }

  handleFocus() {
    this.focus.collectedAmount = true;
    this.validate.amount = '';
  }

  showSelected(type: string) {
    if (type === 'order') {
      if (this.payment.estimate && this.payment.estimate.estimateId) {
        this.isOrderEditable = false;
      }
    } else {
      if (this.payment.customer && this.payment.customer.customerId) {
        this.isCustomerEditable = false;
      }
    }
  }

  /** Getting paid full change */
  handleIsPaidChange(isPaidFull: boolean) {
    this.payment.isPaidFull = isPaidFull;
  }

  /** Getting workflow status change */
  handleworkFlowPaidChange(workFlowPaid: boolean) {
    this.payment.workFlowPaid = workFlowPaid;
  }

  displayNameEmail(fullName: string, email: string) {
    if (fullName && email) {
      return `${fullName} - ${email}`;
    } else if (fullName) {
      return `${fullName}`;
    }
  }

  /** Populate Estimate Details */
  setEstimateDetails(order: any) {
    const customer = order.customer || {};
    this.payment = {
      ...this.payment,
      customer: {
        customerId: customer.customerId,
        fullName: customer.fullName,
        email: customer.email,
        phone: customer.phone,
        phone2: customer.phone2,
        notes: customer.notes,
        displayName: customer.displayName,
      },
      estimate: {
        estimateId: order._id,
        title: order.title,
        code: order.code,
        invCode: order.invCode,
        workFlowStatus: (order.workFlowStatus && order.workFlowStatus.name) || '',
      },
    };

    if (order.vehicle && order.vehicle.vehicleId && order.vehicle.vehicleId._id) {
      this.orderVehicle = order.vehicle.vehicleId;
    }

    this.httpService.getEstimatePaymentDetails(order._id).then(
      (estimate: any) => {
        if (estimate.vehicle && estimate.vehicle.vehicleId) {
          this.orderVehicle = estimate.vehicle.vehicleId;
        }

        this.payment = {
          title: order.title,
          code: order.code,
          paymentType: {},
          collectedAmount: 0,
          isPaidFull: estimate.isPaidFull,
          workFlowPaid: order.workFlowStatus && order.workFlowStatus.name,
          customer: {
            customerId: estimate.customer && estimate.customer.customerId,
            fullName: estimate.customer && estimate.customer.fullName,
            email: estimate.customer && estimate.customer.email,
            phone: estimate.customer && estimate.customer.phone,
            phone2: estimate.customer && estimate.customer.phone2,
            notes: estimate.customer && estimate.customer.notes,
            displayName: estimate.customer && estimate.customer.displayName,
          },
          estimate: {
            estimateId: order._id,
            title: order.title,
            code: order.code,
            invCode: estimate.invCode,
            orderStatus: estimate.orderStatus,
            estimateBy: '',
            workFlowStatus: (order.workFlowStatus && order.workFlowStatus.name) || '',
            cash: this.calculationService.roundOff(estimate.cash),
            cheque: this.calculationService.roundOff(estimate.cheque),
            card: this.calculationService.roundOff(estimate.card),
            creditPayment: this.calculationService.roundOff(estimate.creditPayment),
            thirdParty: this.calculationService.roundOff(estimate.thirdParty),
            total: estimate.total.grand,
            totalDue: estimate.total.grand,
            unpaid: estimate.total.unpaid,
            createdAt: this.dateService.getCurrentDateTimeTz(new Date(estimate.createdAt).getTime()),
          },
          paymentDate: this.dateService.formatDate(new Date(), datetimeFormat.mmmdyyyy),
        };

        this.disabled = this.payment.isPaidFull;
        this.workFlowDisabled = this.payment.workFlowPaid === 'Paid';
        this.remainingBalance = this.calculateRemainingAmount();
        this.payment.collectedAmount = this.calculationService.roundOff(this.remainingBalance);
        this.calculateRemainingBalance();
        this.validate.amount = '';
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  setPaymentMethod() {
    if (this.payment.paymentMethod && this.payment.paymentMethod.methodId && this.paymentMethods.length) {
      const [paymentMethod] = this.paymentMethods.filter(({ _id }) => _id === this.payment.paymentMethod.methodId);
      const [activePaymentType] = this.paymentTypes.filter(({ value }) => this.payment.paymentType === value);

      if (paymentMethod && activePaymentType) {
        this.selectedPaymentMethod = paymentMethod;
        this.activateMethodCard(activePaymentType);
      }
    }
  }

  paymentMethod(data) {
    if (this.afterPayrixPayment) {
      return;
    } else {
      this.isPaymentOnline = data;
      this.showNotes = !data;
    }
  }

  onChangenNote(event) {
    if (this.paymentId) {
      this.payment.customer.notes = event;
    }
  }

  /** Populate Payment Details */
  setPaymentDetails(payment: any) {
    const estimate = payment.estimate || {};
    const customer = payment.customer || {};

    this.paymentId = payment._id;
    this.payment = {
      _id: payment._id,
      refundTypeTitle: payment.isVoidPayment ? 'Void' : 'Refund',
      title: estimate.title || '',
      code: estimate.code || '',
      refundToDate: payment.refundToDate || 0,
      refunds: payment.refunds || [],
      paymentType: payment.paymentType,
      notes: payment.notes,
      card4Digits: payment.card4Digits,
      cardConfNo: payment.cardConfNo,
      checkNo: payment.checkNo,
      collectedAmount: payment.amount,
      isPaidFull: estimate.estimateId && estimate.estimateId.isPaidFull,
      workFlowPaid: estimate.estimateId.workFlowStatus && estimate.estimateId.workFlowStatus.name === 'Paid',
      customer: {
        customerId: customer.customerId,
        fullName: customer.fullName,
        email: customer.email,
        phone: customer.phone,
        phone2: customer.phone2,
        notes: customer.notes,
        displayName: customer.displayName,
      },
      paymentMethod: {
        methodId: payment.paymentMethod.methodId,
        qboId: payment.paymentMethod.qboId,
        name: payment.paymentMethod.name,
        type: payment.paymentMethod.type,
      },
      estimate: estimate,
      paid: sum([
        this.calculationService.roundOff(estimate.estimateId.card),
        this.calculationService.roundOff(estimate.estimateId.cheque),
        this.calculationService.roundOff(estimate.estimateId.cash),
        this.calculationService.roundOff(estimate.estimateId.creditPayment),
        this.calculationService.roundOff(estimate.estimateId.thirdParty),
      ]),
    };
    this.previousCollectedAmount = this.calculationService.roundOff(this.payment.collectedAmount);
    this.disabled = false;
    this.workFlowDisabled = this.payment.workFlowPaid;

    this.setPaymentMethod();

    if (estimate.estimateId) {
      this.payment.estimate = {
        estimateId: estimate.estimateId._id,
        code: estimate.estimateId.code,
        invCode: estimate.estimateId.invCode,
        title: estimate.estimateId.title,
        cash: this.calculationService.roundOff(estimate.estimateId.cash),
        cheque: this.calculationService.roundOff(estimate.estimateId.cheque),
        card: this.calculationService.roundOff(estimate.estimateId.card),
        creditPayment: this.calculationService.roundOff(estimate.estimateId.creditPayment),
        thirdParty: this.calculationService.roundOff(estimate.estimateId.thirdParty),
        total: this.calculationService.roundOff(estimate.estimateId.total.grand),
        totalDue: this.calculationService.roundOff(estimate.estimateId.total.grand),
        unpaid: this.calculationService.roundOff(estimate.estimateId.total.unpaid),
        workFlowStatus: (estimate.estimateId.workFlowStatus && estimate.estimateId.workFlowStatus.name) || '',
        createdAt: this.dateService.getCurrentDateTimeTz(new Date(estimate.estimateId.createdAt).getTime()),
      };

      if (!!payment.paymentDate) {
        if (this.helperService.isAppleDevice()) {
          payment.paymentDate = this.dateService.madeDateStringIOSCompatible(payment.paymentDate);
        }

        this.payment.paymentDate = new Date(payment.paymentDate);
        this.paymentTime = new Date(payment.paymentDate);
      } else {
        this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime());
        this.paymentTime = this.payment.paymentDate;
      }
    }

    this.remainingBalance = this.calculateRemainingAmount();
    this.calculateRemainingBalance();
    if (this.payment.estimate.estimateId) {
      this.getPaymentHistory(this.payment.estimate.estimateId);
    }
  }

  activateMethodCard(method: any, changed = false) {
    if (this.afterPayrixPayment) {
      return;
    }
    if (method.value === 'card') {
      if (this.featureIsPayRixEnable) {
        this.isPaymentOnline = true;
      }
      if (this.isPaymentOnline && this.isPayrixConnected) {
        this.showNotes = false;
      } else {
        this.showNotes = true;
      }
      this.paymentMethods = [...this.cardPaymentMethods];
    } else if (method.value === 'cash') {
      this.isPaymentOnline = false;
      this.showNotes = true;
      this.paymentMethods = [...this.cashPaymentMethods];
    } else {
      this.isPaymentOnline = false;
      this.showNotes = true;
      this.paymentMethods = [...this.otherPaymentMethods];
    }

    if (this.paymentMethods.length) {
      this.activePayment = method;
      if (changed) {
        this.selectedPaymentMethod = this.paymentMethods[0];
      }
    }
  }

  /** Fetch payments and set the qboId for the non credit card payment */
  fetchPaymentMethods() {
    if (!environment.isMock) {
      this.isMethodLoading = true;
      this.httpService.getActivePaymentMethods().then(
        (paymentMethods: any[]) => {
          this.paymentMethods = paymentMethods;
          paymentMethods.forEach((method) => {
            if (method.type === 'CREDIT_CARD') {
              this.cardPaymentMethods.push(method);
            } else if (method.type === 'CASH' && !this.isQboConnected) {
              this.cashPaymentMethods.push(method);
            } else if (method.name.toLowerCase().includes('cash') && this.isQboConnected) {
              this.cashPaymentMethods.push(method);
            } else {
              this.otherPaymentMethods.push(method);
            }
          });

          this.paymentMethodsActive = {
            card: !!this.cardPaymentMethods.length,
            cash: !!this.cashPaymentMethods.length,
            cheque: !!this.otherPaymentMethods.length,
          };

          if (!this.paymentId && this.cashPaymentMethods.length) {
            this.selectedPaymentMethod = this.cashPaymentMethods[0];
            this.activateMethodCard(this.paymentTypes[0]);
          }

          if (!this.paymentId) {
            if (this.cashPaymentMethods.length) {
              this.selectedPaymentMethod = this.cashPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[0]);
            } else if (this.cardPaymentMethods.length) {
              this.selectedPaymentMethod = this.cardPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[1]);
            } else if (this.otherPaymentMethods.length) {
              this.selectedPaymentMethod = this.otherPaymentMethods[0];
              this.activateMethodCard(this.paymentTypes[2]);
            }
          }
          this.isMethodLoading = false;
          this.setPaymentMethod();
        },
        (err) => {
          this.isMethodLoading = false;
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  /** Fetching payment history */
  getPaymentHistory(estimateId: string) {
    this.httpService.getPaymentHistoryByOrderId(estimateId).then(
      (payments: any[]) => {
        this.paymentHistory = [];

        if (payments && payments.length) {
          this.paymentHistory = [];
          payments.forEach((payment: any) => {
            if (payment.refunds && payment.refunds.length) {
              payment.refunds.forEach((refund) => {
                this.paymentHistory.push({
                  createdAt: this.dateService.getCurrentDateTimeTz(new Date(refund.refundDate).getTime()),
                  tooltip: '',
                  amount: refund.amount,
                  paymentType: 'Refund',
                  title: refund.isVoid ? 'Void' : 'Refund',
                });
              });
            }

            this.paymentHistory.push({
              amount: payment.amount,
              madeBy: payment.paymentHistory && payment.paymentHistory.length ? payment.paymentHistory[0].fullName : '',
              isOnline: payment.isOnline,
              isCardSwipe: payment.isCardSwipe,
              paymentType: payment.paymentType,
              cardSource: this.helperService.paymentToolTipTxt(payment, payment.paymentMethod),
              cardType: payment.cardType,
              card4Digits: payment.card4Digits,
              parRix: payment.payrixResponse,
              createdAt: !!payment.paymentDate ? new Date(payment.paymentDate) : this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime()),
              tooltip: this.helperService.createPaymentLogTooltip(payment),
            });
          });

          this.paymentHistory = orderBy(this.paymentHistory, ['createdAt'], 'desc');
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }
}
